<template>
  <component :is="currentComponent" :key="etapeKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')"/>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';
import Etape2Inner from './Etape2Inner.vue';
import { taggage, taggageView, resetTag } from '@/utils/taggage.js';

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const currentComponent = ref(Etape2Inner);

const etapeKey = ref(0);

defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);


onMounted(() => {
  //console.log('Etape2 mounted');
  resetTag(2);
  taggage('configurateur_open', 'etape_2', 'display', { tealium_event: 'select_content' });
  //taggageView('XXXX', 'Orange', 'XXXX', 'portail', 'RES', 'global', 'XXXX', 'configurateur_etape_2', 'XXXX', 'Pack Open', 'internet', 'XXXX');
  taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'configurateur_etape_2', 'Pack Open', 'internet', window.devicePixelRatio);
  nextTick(() => {
    const anchorTitle = document.querySelector('.anchorTitle');
    if (anchorTitle) {
      anchorTitle.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  });
})


</script>
